import React from 'react';
import { useNavigate } from 'react-router';
import { FeatherArrowRight, FeatherX } from '@subframe/core';
import { Alert } from '../ui/components/Alert';
import { Button } from '../ui/components/Button';
import { IconButton } from '../ui/components/IconButton';

interface MigrateBannerProps {
  onDismiss: () => void;
}

/**
 * A CTA banner shown to authenticated users who have NFTs listed on other marketplaces.
 * Encourages them to copy listings to xrp.deals for lower fees.
 * Displays on all pages and can be dismissed for the current session.
 */
export const MigrateBanner: React.FC<MigrateBannerProps> = ({ onDismiss }) => {
  const navigate = useNavigate();

  return (
    <div className="w-full max-w-[1400px] px-6 pt-6 mobile:px-4 mobile:pt-4">
      <Alert
        variant="warning"
        icon={<FeatherArrowRight />}
        title="You have NFTs listed for sale only on other marketplaces"
        description="Copy your NFT listings to xrp.deals for more exposure"
        actions={
          <div className="flex items-center gap-2">
            <Button
              variant="brand-primary"
              size="small"
              onClick={() => navigate('/migrate')}
            >
              Copy Listings
            </Button>
            <IconButton
              icon={<FeatherX />}
              size="small"
              onClick={onDismiss}
            />
          </div>
        }
      />
    </div>
  );
};
